import { CCardFooter } from "@coreui/react"
import { Box, Button, Card, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableHead, TableRow, TextField } from "@mui/material"
import { useLocation, useNavigate } from "react-router-dom";
import { T_Product } from "../../../common/model/productModel";
import { useEffect, useState } from "react";
import { initialAlert, useAlert } from "../../../provider/AlertContextProvider";
import apis from "../../../common/apis";

export default function ProductEdit(){

       const { state } = useLocation();
    // state.inqueryData 에서 넘어온 item 객체를 꺼낼 수 있습니다.
    const inputData = state?.item;

    const nav = useNavigate();
    const [data,setData] = useState<T_Product>({});
    const {alert,setAlert} = useAlert();
    const [isPost,setIsPost] = useState(false)


       const infoData = async()=>{
        const result = await apis.product.productInfo({idx:inputData.idx})
        console.log("result:",result)
        if(result.code=="1"){
            setData(result.data);
        }
    }   



  const updateData = async()=>{

      setAlert({...alert,title:"확인",msg:"정말로 수정 하시겠습니가?",visible:true,buttonList:[
            {
                text:"예"
                ,variant:"contained"
                ,onPress:async()=>{
                   const result = await apis.product.productUpdate(data)
                    if(result.code=="1"){
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"수정이 완료되었습니다."})
                        nav("/product")
                    }else{
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"수정중 오류가 발생했습니다.."})
                    }
           
                }
            },{
                text:"아니요"
                ,variant:"outlined"
                ,onPress:()=>{
                    setAlert(initialAlert);
                }
            }
        ]})

   
  }



useEffect(()=>{
    infoData();
},[])

            return(
            <>
            <Card >
                <CardHeader title="제품 등록" sx={{pb:0,mb:0}}/>
                <CardContent>
                    <Divider />
                <Table  stickyHeader aria-label="sticky table"  sx={{borderTopWidth:2
                }} > 
                    <TableHead />
                    <TableBody>
                    <TableRow>
                            <TableCell component="th" scope="row" sx={{width:150}}>
                                타입
                                </TableCell>      
                                <TableCell sx={{textAlign:'left'}}>
                                <TextField  size="small" fullWidth value={data.type || ''} onChange={(event)=>{setData({...data,type:event.target.value})}} />
                                </TableCell>      

                    </TableRow>                             
                    <TableRow>
                            <TableCell component="th" scope="row" sx={{width:150}}>
                                코드
                                </TableCell>      
                                <TableCell sx={{textAlign:'left'}}>
                                <TextField  size="small" fullWidth value={data.code || ''} onChange={(event)=>{setData({...data,code:event.target.value})}} />
                                </TableCell>      

                    </TableRow>        
                    {/* <TableRow>
                            <TableCell component="th" scope="row" sx={{width:150}}>
                                제품명
                                </TableCell>      
                                <TableCell sx={{textAlign:'left'}}>
                                <TextField  size="small" fullWidth value={data.name || ''} onChange={(event)=>{setData({...data,name:event.target.value})}} />
                                </TableCell>      

                    </TableRow>         */}
                    <TableRow>
                            <TableCell component="th" scope="row" sx={{width:150}}>
                                가격
                                </TableCell>      
                                <TableCell sx={{textAlign:'left'}}>
                                <TextField  size="small" fullWidth value={data.price || ''} onChange={(event)=>{setData({...data,price:event.target.value})}} />
                                <TextField  size="small" fullWidth value={data.price2 || ''} onChange={(event)=>{setData({...data,price2:event.target.value})}} />
                                </TableCell>      

                    </TableRow>       

                <TableRow>
                            <TableCell component="th" scope="row" sx={{width:150}}>
                                비고
                                </TableCell>      
                                <TableCell sx={{textAlign:'left'}}>
                                    <TextField multiline
                                    rows={10}
                                    fullWidth 
                                    value={data.content || ''} onChange={(event)=>{setData({...data,content:event.target.value})}}
                                />                                           
                                </TableCell>      

                </TableRow>        
                </TableBody>

                </Table>

                </CardContent>
                <CCardFooter style={{   display: 'flex',justifyContent:'center',textAlign:'center',paddingBottom:10, gap: '1rem'}}  >
                <Button variant="contained" onClick={()=>{
            updateData();
                }}>수정</Button>
                <Button variant="outlined" onClick={()=>{
            //  nav(-1);
                }}>취소</Button>

                </CCardFooter>
            </Card>
            </>
    )
}